import * as gql from 'fake-tag';

const categoryFields = `
              aceCategoryCode
              title`;

export const categoryString = `
              ... on drivingCategories_Category {
                ${categoryFields}
              }
              ... on aarpCategories_Category {
                ${categoryFields}
              }
              ... on realEstateCategories_Category {
                ${categoryFields}
              }
              ... on mortgageCategories_Category {
                ${categoryFields}
              }`;

export const ProductFragment = {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call
  product: gql` fragment ProductEntry on xgritProduct_Entry {
                  aceRealEstateProductCategory {
                    ... on realEstateCategories_Category {
                      ${categoryFields}
                    }
                  }
                  insuranceProductCategory {
                    ... on insuranceCategories_Category {
                      ${categoryFields}
                    }
                  }
                  mortgageProductCategory {
                    ... on mortgageCategories_Category {
                      ${categoryFields}
                    }
                  }
                  productCategory {
                    ${categoryString}
                  }
                  productPageUrl
                  productState
                  xgritBundleCoupon
                  xgritCoupon
                  xgritProductDisableRsa
                  showGuaranteeText
                  productPills
                  xgritProductId
                  webinarTitle
                  webinarContent
                  webinarCourseIds {
                    courseid
                  }
                  schemaAdditions
                }`,
};
